import React from "react";
import PropTypes from "prop-types";
import Autocomplete from "react-autocomplete";
import "./AutocompleteStyles.scss";

const wrapperStyle = {
  display: "block",
  width: "100%",
  height: "100%",
};

const AutocompleteView = ({
  className = "",
  error,
  placeholder,
  label,
  disabled,
  items = [],
  ...props
}) => {
  return (
    <div className={`wrapper auto_complete ${className}`}>
      <span className={`select__label H5-Input-Title-2 text-muted`}>
        {label}
      </span>

      <Autocomplete
        getItemValue={(item) => item.value}
        items={items}
        renderItem={(item, isHighlighted) => (
          <div key={Math.random()} className="item">
            <b>{item.value}</b>
            <span className="itemLabel">{item.label}</span>
          </div>
        )}
        renderMenu={(items, value) => (
          <div
            key={Math.random()}
            className="menu"
            style={!items.length ? { display: "none" } : {}}
            // style={!items.length && !value.length ? { display: "none" } : {}}
          >
            {items}
            {/* {value.length > 0 && items} */}
          </div>
        )}
        renderInput={(props) => (
          <input
            disabled={disabled}
            className={`${error ? "input_error" : ""}`}
            placeholder={placeholder}
            {...props}
          />
        )}
        wrapperStyle={wrapperStyle}
        {...props}
      />

      <div className={`error`}>{error ? error : ""}</div>
    </div>
  );
};

AutocompleteView.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  items: PropTypes.array,
  disabled: PropTypes.bool,
};

export default AutocompleteView;
